export enum LocalStorageKeys {
  examSettings = 'ksga-exam-settings',
  evaluationSettings = 'ksga-evaluation-settings',
  studentsEvaluations = 'ksga-students-evaluations',
  apiData = 'ksga-api-data',
  staticContent = 'ksga-static-content',
}
